export default __webpack_public_path__ + "static/media/autofact-logo-white.10b560b0.svg";